// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\---core-app---App-module__base {
  margin: 0;
  height: 100vh;
  padding: 0;
}

.\\---core-app---App-module__root {
  display: flex;
  height: 100%;
}

.\\---core-app---App-module__main {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  background-color: #f7f7f7;
  padding-left: 1em;
  padding-top: 1em;
}

.\\---core-app---App-module__iframe {
  flex-grow: 1;

  border: none;
}
`, "",{"version":3,"sources":["webpack://./../core/app/App.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;;EAEZ,YAAY;AACd","sourcesContent":[".base {\n  margin: 0;\n  height: 100vh;\n  padding: 0;\n}\n\n.root {\n  display: flex;\n  height: 100%;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  background-color: #f7f7f7;\n  padding-left: 1em;\n  padding-top: 1em;\n}\n\n.iframe {\n  flex-grow: 1;\n\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var base = `---core-app---App-module__base`;
export var root = `---core-app---App-module__root`;
export var main = `---core-app---App-module__main`;
export var iframe = `---core-app---App-module__iframe`;
export default ___CSS_LOADER_EXPORT___;
